import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardTitle, Form, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { User } from '../../../clients/aasServerClient.generated';
import { logoutAs, sendPasswordReset, updateAccount } from '../../../stores/auth/actionCreators';
import { currentUser, isLoggedInAs } from '../../../stores/auth/selectors';
import { isLoading } from '../../../stores/navigation/selectors';
import { RootState } from '../../../stores/store';
import FormInput from '../../common/FormInput';
import { LoadingButton } from '../../navigation/LoadingButton';

interface Props extends LocalizeContextProps, RouteComponentProps {
    loading: boolean;
    currentUser: User;
    loggedInAs?: boolean;

    updateAccount: (
        email: string, confirmEmail: string,
        firstName: string, lastName: string
    ) => void;
    logoutAs: () => void;
}

interface State {
    email: string;
    confirm_email: string;
    first_name: string;
    last_name: string;
}

class UpdateAccountDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            confirm_email: '',
            email: props.currentUser?.email ?? '',
            first_name: '',
            last_name: '',
        };
    }

    public handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            [event.target.name]: event.target.type === 'checkbox' ?
                event.target.checked : event.target.value,
            // tslint:disable-next-line:no-any
        } as any);
    }

    // tslint:disable-next-line:no-any
    public sendResetPassword = (e: React.SyntheticEvent<any, Event>) => {
        e.preventDefault();
        this.props.updateAccount(
            this.state.email,
            this.state.confirm_email,
            this.state.first_name,
            this.state.last_name
        );
    }

    public render() {
        const t = this.props.translate;
        return (
            <Card>
                <CardBody>
                    <CardTitle tag="h3">{t('update.header.update')}</CardTitle>
                    <Form>
                        <p className="lead">{t('update.text.info')}</p>
                        <FormInput
                            name="first_name"
                            fullName={t('update.field.firstName') as string}
                            type="text"
                            value={this.state.first_name}
                            onChange={this.handleInputChange}
                        />
                        <FormInput
                            name="last_name"
                            fullName={t('update.field.lastName') as string}
                            type="text"
                            value={this.state.last_name}
                            onChange={this.handleInputChange}
                        />
                        <FormInput
                            name="email"
                            fullName={t('update.field.email') as string}
                            value={this.state.email}
                            onChange={this.handleInputChange}
                            type="text"
                        />
                        <FormInput
                            name="confirm_email"
                            fullName={t('update.field.confirmEmail') as string}
                            value={this.state.confirm_email}
                            onChange={this.handleInputChange}
                            type="text"
                        />
                        {this.props.loggedInAs ? (
                            <Button
                                color="link"
                                onClick={() => {
                                    this.props.logoutAs();
                                }}
                            >
                                {t('update.link.logoutAs')}
                            </Button>
                        ) : (
                                <Button color="link" onClick={() => this.props.history.push('/logout')}>
                                    {t('update.link.logout')}
                                </Button>
                            )}
                        <LoadingButton
                            fixedWidth={true}
                            color="primary"
                            className={classnames('float-right', 'save-btn', 'loginBtn')}
                            type="submit"
                            loading={this.props.loading}
                            onClick={this.sendResetPassword}
                            onSubmit={this.sendResetPassword}
                        >
                            {this.props.loading ? t('update.button.updatingAccount') :
                                t('update.button.updateAccount')}
                        </LoadingButton>

                    </Form>
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    currentUser: currentUser(state)!,
    loading: isLoading(state),
    loggedInAs: isLoggedInAs(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logoutAs: () => dispatch(logoutAs()),
    updateAccount: (
        email: string, confirmEmail: string,
        firstName: string, lastName: string) =>
        dispatch(updateAccount(email, confirmEmail, firstName, lastName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(UpdateAccountDialog)));
